import { render, staticRenderFns } from "./accessoriyList.vue?vue&type=template&id=0713f102&scoped=true"
import script from "./accessoriyList.vue?vue&type=script&lang=js"
export * from "./accessoriyList.vue?vue&type=script&lang=js"
import style0 from "./accessoriyList.vue?vue&type=style&index=0&id=0713f102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0713f102",
  null
  
)

export default component.exports